/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicBranches.internal

import features.publicBranches.models.PublicBranchesModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.publicBranches.internal.PublicBranchesUseCase.Params

internal class PublicBranchesUseCase : AsyncUseCase<PublicBranchesModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val perPage: Int
    )

    private val publicBranchesService: PublicBranchesService = PublicBranchesServiceImpl()

    override suspend fun run(params: Params): Result<PublicBranchesModel> {
        return publicBranchesService.getPublicBranches(
            overrideHeaders = params.overrideHeaders,
            perPage = params.perPage
        )
    }
}
